import { Routes } from '@angular/router';
import { LandingPageComponent } from '../landing-page/components/landing-page.component';
import { SiteListComponent } from '../sites/components/site-list/site-list.component';
import { SiteEditorComponent } from '../sites/components/site-editor/site-editor.component';
import { ProductViewComponent } from '../products/components/product-view/product-view.component';
import { SiteViewComponent } from '../sites/components/site-view/site-view.component';
import { ExistingSiteEditorComponent } from '../sites/components/existing-site-editor/existing-site-editor.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'sites',
    component: SiteListComponent 
  },
  {
    path: 'sites/new',
    component: SiteEditorComponent 
  },
  {
    path: 'sites/:id/edit',
    component: ExistingSiteEditorComponent
  },
  {
    path: 'sites/:id',
    component: SiteViewComponent
  },
  {
    path: 'products/:id',
    component: ProductViewComponent
  }
]